<template>
<div>
  <ResultsShow :key="this.$route.params.query" />
</div>
</template>

<script>
import { mapActions } from "vuex";
import ResultsShow from "@/components/General/ResultsShow";
export default {
  components:{
    ResultsShow
  },
}
</script>
